// @owners { team: patients }
import { type ReduxStateShared } from '~shared/types';

export const getDraftMessage = (state: ReduxStateShared) => state.altoAssistant.draftMessage;
